import React, { useState } from 'react';
import { Grid, Button, Checkbox, FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import {
	BaseTextField,
	BaseSelectField,
	BaseButton,
	BaseMultipleSelectField,
} from '../../UIWidgets';
import SubProductList from '../subProductListView';
import SubProductDialog from '../subProductModal';
import {
	itemStatus,
	dogKinds,
	catKinds,
	itemType,
} from './productInfoConstants';

export const useStyles = makeStyles(theme => ({
	uploadButton: {
		marginTop: '10px',
	},
	warning: {
		backgroundColor: theme.palette.warning.main,
		color: '#FFF',
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'space-between',
	},
}));

const ProductInfoInputView = ({
	product,
	errors,
	handleChange,
	handleCheck,
	handleCreateSubProduct,
	handleDeleteSubProduct,
	handleClearSubProduct,
	handleMultipleSelect,
	handleUpdateProduct,
}) => {
	const {
		name,
		status,
		type,
		originalPrice,
		currentPrice,
		kinds,
		searchWeight,
		salesVolume,
		description,
		isRecommended,
	} = product;

	const classes = useStyles();

	const [subProductEditing, setSubProductEditing] = useState();

	const [subProductModelIsOpen, setSubProductModelIsOpen] = useState(false);

	const itemName = () => (
		<BaseTextField
			title='商品名称'
			error={hasError('name')}
			name='name'
			onChange={handleChange}
			value={name}
		/>
	);

	const itemStatusView = () => (
		<BaseSelectField
			title='商品状态'
			name='status'
			error={hasError('status')}
			onChange={handleChange}
			value={status}
			options={itemStatus}
		/>
	);

	const itemTypeView = () => (
		<BaseSelectField
			title='商品类型（猫/狗）'
			name='type'
			error={hasError('type')}
			onChange={e => {
				handleUpdateProduct({
					kinds: [],
					[e.target.name]: e.target.value,
				});
			}}
			value={type}
			options={itemType}
		/>
	);

	const itemKindsView = () => {
		return (
			<BaseMultipleSelectField
				title='商品分类'
				error={hasError('kinds')}
				options={type === '汪星人' ? dogKinds : catKinds}
				handleChange={handleMultipleSelect}
				values={kinds}
				name='kinds'
			/>
		);
	};

	const originalPriceView = () => (
		<BaseTextField
			title='原价格'
			error={hasError('originalPrice')}
			name='originalPrice'
			onChange={handleChange}
			value={originalPrice}
			type='number'
		/>
	);

	const currentPriceView = () => (
		<BaseTextField
			title='实际价格'
			error={hasError('currentPrice')}
			name='currentPrice'
			onChange={handleChange}
			value={currentPrice}
			type='number'
		/>
	);

	const salesVolumeView = () => (
		<BaseTextField
			title='销量'
			name='salesVolume'
			onChange={handleChange}
			value={salesVolume}
			type='number'
		/>
	);

	const searchWeightView = () => (
		<BaseTextField
			title='搜索权重（默认50，越高越靠前)'
			name='searchWeight'
			onChange={handleChange}
			value={searchWeight}
			type='number'
		/>
	);

	const descriptionView = () => (
		<BaseTextField
			multiline
			title='商品描述'
			error={hasError('description')}
			name='description'
			onChange={handleChange}
			value={description}
			rows='6'
		/>
	);

	const isRecommendedView = () => (
		<FormControlLabel
			control={
				<Checkbox
					checked={isRecommended}
					color='primary'
					name='isRecommended'
					onChange={handleCheck}
				/>
			}
			label='是否推荐上首页'
		/>
	);

	const subProductButtonView = () => (
		<>
			<Grid item xs={12}>
				<BaseButton
					title='添加副商品'
					fullWidth
					onClick={() => {
						setSubProductModelIsOpen(true);
						setSubProductEditing();
					}}
				/>
			</Grid>
			<Grid item xs={12}>
				{product?.subProducts?.length > 0 ? (
					<Button
						fullWidth
						variant='contained'
						className={classes.warning}
						onClick={handleClearSubProduct}
					>
						清空副商品
					</Button>
				) : (
					''
				)}
			</Grid>
		</>
	);

	const hasError = field => (errors[field] ? true : false);

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				{itemName()}
			</Grid>

			<Grid container item xs={12} spacing={1}>
				<Grid item xs={6}>
					{itemStatusView()}
				</Grid>
				<Grid item xs={6}>
					{itemTypeView()}
				</Grid>
			</Grid>

			<Grid item xs={12}>
				{itemKindsView()}
			</Grid>
			<Grid container item xs={12} spacing={1}>
				<Grid item xs={6}>
					{originalPriceView()}
				</Grid>
				<Grid item xs={6}>
					{currentPriceView()}
				</Grid>
			</Grid>

			<Grid item xs={12}>
				<SubProductList
					subProducts={product.subProducts}
					handleSelectSubProduct={product => {
						setSubProductEditing(product);
						setSubProductModelIsOpen(true);
					}}
				/>
			</Grid>
			{subProductButtonView()}

			<Grid container item xs={12} spacing={1}>
				<Grid item xs={6}>
					{salesVolumeView()}
				</Grid>
				<Grid item xs={6}>
					{searchWeightView()}
				</Grid>
			</Grid>

			<Grid item xs={12}>
				{descriptionView()}
			</Grid>

			<Grid item xs={12}>
				{isRecommendedView()}
			</Grid>

			<SubProductDialog
				subProduct={subProductEditing}
				isOpen={subProductModelIsOpen}
				onClose={() => {
					setSubProductModelIsOpen(false);
				}}
				handleCreate={handleCreateSubProduct}
				handleDelete={handleDeleteSubProduct}
			/>
		</Grid>
	);
};

export default ProductInfoInputView;
